import React from "react";
import { format, parseISO } from "date-fns";

export const createQueryParams = (data, n = undefined, s = undefined) => {
  let url = '';
  if (n && s) url += `page=${n}&limit=${s}&`;
  if (!data) return url;

  const queryParams = Object.entries(data)
    .filter(([_, value]) => value !== undefined && value !== null && value)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join("&");

  if (queryParams) {
    url += `${queryParams}`;
  }

  return url;
};

/**
 * Convert date to specified format
 * @param {string|Date} dateValue - The date to format (can be string or Date object)
 * @param {string} formatString - The desired format (e.g., 'yyyy-MM-dd', 'dd/MM/yyyy', 'MMM dd, yyyy')
 * @returns {string} Formatted date string
 */
export const formatDate = (dateValue, formatString = 'yyyy-MM-dd') => {
  try {
    if (!dateValue) return '';
    
    let date;
    
    // Handle different input types
    if (typeof dateValue === 'string') {
      // Try to parse ISO string first, then fallback to new Date()
      try {
        date = parseISO(dateValue);
      } catch {
        date = new Date(dateValue);
      }
    } else if (dateValue instanceof Date) {
      date = dateValue;
    } else {
      return '';
    }
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return '';
    }
    
    return format(date, formatString);
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};

// Common date format presets
export const DATE_FORMATS = {
  SHORT: 'dd/MM/yyyy',
  LONG: 'dd MMM yyyy',
  ISO: 'yyyy-MM-dd',
  DATETIME: 'dd/MM/yyyy HH:mm',
  TIME: 'HH:mm',
  MONTH_YEAR: 'MMMM yyyy',
  DAY_MONTH: 'dd MMM'
};

export const FormLoader = () => <div>...Loading</div>;

export const NoDataFound = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    No Data Found
  </div>
);

